import './App.css';
import Home from './components/Home'; // Ensure the filename is correct

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
